import inbox from './../assets/images/inbox.svg';
import send from './../assets/images/send.png';
import star from './../assets/images/Star.png';
import trash from './../assets/images/trash-2.png';
import addLabel from './../assets/images/addLabel.png';
import addIcon from './../assets/images/Add.png';

const Navbar = () => {
  return (
    <aside className="w-1/8 bg-midgrey">
      <div className="flex flex-col">
        <div className="pt-[24px] pr-[10px] pb-[8px] pl-[10px] flex justify-center">
          <button className="text-white bg-blue-600 py-[8px] px-[14px] flex justify-center items-center rounded-full text-[14px] w-[134px] h-[40px] whitespace-nowrap new-message-btn">
            <img
              src={addIcon}
              alt="Plus Icon"
              className="w-5 h-5 mr-2 new-message-icon"
            />
            New Message
          </button>
          <style>{`
            @media (min-width: 1920px) {
              .new-message-btn {
                padding-block: 16px;
                padding-inline: 32px;
                width: 190px; 
                height: 55px; 
                font-size: 18px; 
              }
              .new-message-icon {
                width: 32px; 
                height: 32px; 
                marging-left: 16px
              }
            }
        `}</style>
        </div>
        <div className="border-b-[0.5px] mt-4 border-bordergrey"></div>
        <nav className="mt-2">
          <ul className="flex flex-col text-left pl-[31px] pt-7 gap-[15px] ">
            <li className="flex items-center justify-start text-black font-semibold">
              <img
                src={inbox}
                alt="Inbox Icon"
                className="h-5 w-5 text-gray-400 mr-2"
              />
              Inbox
            </li>
            <li className="flex items-center justify-start text-black font-semibold">
              <img
                src={send}
                alt="Inbox Icon"
                className="h-5 w-5 text-gray-400 mr-2"
              />
              Sent
            </li>
            <li className="flex items-center text-black font-semibold">
              <img
                src={star}
                alt="Inbox Icon"
                className="h-5 w-5 text-gray-400 mr-2"
              />
              Favourites
            </li>
            <li className="flex items-center justify-start text-black font-semibold">
              <img
                src={trash}
                alt="Inbox Icon"
                className="h-5 w-5 text-gray-400 mr-2"
              />
              Trash
            </li>
          </ul>
        </nav>

        <div className="ml-[26px] mt-[28px]">
          <div className="font-roboto text-[12px] leading-[14.06px] tracking-[0.375em] text-tab-text">
            LABELS
          </div>
          <ul className="mt-4 space-y-4">
            <li className="flex items-center">
              <span className="inline-block h-[8px] w-[8px] bg-blue-500 rounded-full mr-4"></span>
              <span className="text-black text-sm">Work</span>
            </li>
            <li className="flex items-center">
              <span className="inline-block h-[8px] w-[8px] bg-green-500 rounded-full mr-4"></span>
              <span className="text-black text-sm">Personal</span>
            </li>
            <li className="flex items-center">
              <span className="inline-block h-[8px] w-[8px] bg-orange-400 rounded-full mr-4"></span>
              <span className="text-black text-sm">Priority</span>
            </li>
            <li className="flex items-center">
              <span className="inline-block h-[8px] w-[8px] bg-yellow-600 rounded-full mr-4"></span>
              <span className="text-black text-sm">Misc.</span>
            </li>
          </ul>

          <div className="flex items-center mt-4 text-gray-500 cursor-pointer">
            <span className="h-[20px] w-[20px] flex justify-center items-center mr-4">
              <img src={addLabel} />
            </span>
            <span className="text-sm">Add label</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Navbar;
